import React from "react";
import ProjectCard from "./projectCard";
import INFO from "../../data/user";
import "./styles/allProjects.css";

const AllProjects = ({ limit }) => {
	const displayProjects = limit ? INFO.projects.slice(0, limit) : INFO.projects;

	return (
		<div className="all-projects-grid">
			{displayProjects.map((project, index) => (
				<ProjectCard key={project.id || index} project={project} index={index} />
			))}
		</div>
	);
};

export default AllProjects;
